module.exports = __webpack_public_path__ + "img/text-classify5.1df114dd.png";